import Vue from 'vue';

Vue.filter('money', (value: number) => {
    const result = Math.round(value * 100) / 100;
    return result.toFixed(2);
});
